<template>
  <v-app>
    <v-content>
      <container-slot>
        <v-col col="12" md="6" class="mx-auto">
          <v-card>
            <v-toolbar color="light-blue lighten-4" dark>
              <v-toolbar-title class="mx-auto">
                <v-img :src="navLogo" :max-width="imageWidth" class="mx-auto">
                </v-img>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="padless-y">
              <v-container>
                <v-row>
                  <v-col cols="12" class="my-2 text-center">
                    <span
                      class="display-1 font-weight-bold grey--text text--darken-3"
                      >Web Admin</span
                    >
                  </v-col>
                  <v-col cols="12" v-show="successSubmit">
                    <v-alert
                      :type="!error ? (info ? `info` : `success`) : `error`"
                      ref="alert"
                      dismissible
                      @input="close"
                      class="noMarg"
                      v-show="successSubmit"
                    >
                      {{ msg }}
                    </v-alert>
                  </v-col>
                  <v-col cols="12">
                    <v-form ref="loginForm" v-model="valid">
                      <v-text-field
                        @focus="focus"
                        prepend-icon="mdi-account"
                        name="userName"
                        label="Username"
                        id="userName"
                        type="text"
                        v-model="userName"
                        :rules="userNameRules"
                        ref="userNameInput"
                        outlined
                        required
                      >
                      </v-text-field>
                      <v-text-field
                        @focus="focus"
                        prepend-icon="mdi-lock"
                        name="password"
                        label="Password"
                        id="password"
                        type="password"
                        v-model="password"
                        :rules="passwordRules"
                        ref="passwordInput"
                        outlined
                        required
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="padless-t">
              <v-container class="padless-y">
                <v-row class="padless-y">
                  <v-col cols="12" class="text-center padless-t">
                    <div>
                      <v-btn
                        color="primary"
                        @click="submitForm"
                        :disabled="!valid || loading"
                        :loading="loading"
                        >Submit</v-btn
                      >
                      <v-btn
                        color="blue-grey"
                        class="text--white"
                        @click="$refs.loginForm.reset()"
                      >
                        Reset
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-col>
      </container-slot>
    </v-content>
  </v-app>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
import { lsUtils, JWTVerify } from "@/utils/localStorageUtils";
import { userLogin } from "@/utils/graphqlQuery";
import navLogo from "@/assets/nav-logo.png";

export default {
  computed: {
    breakpoints() {
      return {
        smAndDown: this.$vuetify.breakpoint.smAndDown,
        mdAndUp: this.$vuetify.breakpoint.mdAndUp,
      };
    },
    imageWidth() {
      return this.$vuetify.breakpoint.smAndDown ? 150 : 180;
    },
  },
  data() {
    return {
      error: false,
      info: false,
      loading: false,
      msg: "",
      navLogo,
      password: "",
      passwordRules: [(v) => !!v || "Password Field can't empty"],
      successSubmit: false,
      userName: "",
      userNameRules: [(v) => !!v || "Username Field can't empty"],
      valid: false,
    };
  },
  components: {
    ContainerSlot,
  },
  methods: {
    close() {
      this.successSubmit = false;
      this.error = false;
    },
    focus(e) {
      e.target.addEventListener("keyup", (ev) => {
        if (ev.keyCode === 13) {
          this.submitForm();
        }
      });
    },
    async submitForm() {
      this.successSubmit = false;
      if (this.valid) {
        this.loading = true;
        this.info = false;
        try {
          const { data } = await this.$apollo.query({
            query: userLogin,
            variables: {
              userName: this.userName,
              password: this.password,
            },
          });
          const { success, token, msg } = data.userLogin;
          if (!success) {
            throw new Error(msg);
          }
          try {
            const userData = JWTVerify(token, process.env.VUE_APP_SECRET_KEY);
            lsUtils.setItem(
              "userToken",
              { token, userData },
              12 * 60 * 60 * 1000
            );
            this.error = false;
            this.msg = msg;

            // No problem?, here we go...
            this.$router.push("/");
          } catch (error) {
            throw new Error(error.message);
          }
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.successSubmit = true;
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    if (Object.keys(this.$route.query).includes("redir")) {
      this.msg = "Password changed, re-login";
      this.info = true;
      this.successSubmit = true;
    }
  },
  name: "LoginPage",
  title() {
    return "Login";
  },
};
</script>

<style scoped>
.padless {
  padding: 0;
}
.padless-y {
  padding-top: 0;
  padding-bottom: 0;
}
.padless-t {
  padding-top: 0;
}
.padless-b {
  padding-bottom: 0;
}
.padless-l {
  padding-left: 0;
}
.padless-r {
  padding-right: 0;
}
</style>
